// Private

// Public
const openCommunity = () => window.open('//community.ply.io/getting-started', '_blank');

const InAppHelpMenuService = {
	openCommunity,
};

export default InAppHelpMenuService;
